/** Phân quyền — phiếu xuất kho */
export const PHIEU_XUAT_KHO_PERMISSION_CODES = {
  WEB_BH_PHIEU_XUAT_KHO_LIST: 'WEB_BH_PHIEU_XUAT_KHO_LIST',
  WEB_BH_PHIEU_XUAT_KHO_DETAIL: 'WEB_BH_PHIEU_XUAT_KHO_DETAIL',
  WEB_BH_PHIEU_XUAT_KHO_ADD: 'WEB_BH_PHIEU_XUAT_KHO_ADD',
  WEB_BH_PHIEU_XUAT_KHO_EDIT: 'WEB_BH_PHIEU_XUAT_KHO_EDIT',
  WEB_BH_PHIEU_XUAT_KHO_DELETE: 'WEB_BH_PHIEU_XUAT_KHO_DELETE',
  WEB_BH_PHIEU_XUAT_KHO_STATUS: 'WEB_BH_PHIEU_XUAT_KHO_STATUS',
  WEB_BH_PHIEU_XUAT_KHO_IMPORT: 'WEB_BH_PHIEU_XUAT_KHO_IMPORT',
  WEB_BH_PHIEU_XUAT_KHO_EXPORT: 'WEB_BH_PHIEU_XUAT_KHO_EXPORT',
} as const

export type PhieuXuatKhoPermissionCode =
  (typeof PHIEU_XUAT_KHO_PERMISSION_CODES)[keyof typeof PHIEU_XUAT_KHO_PERMISSION_CODES]

export const PHIEU_XUAT_KHO_MUTATE_PERMISSIONS = [
  PHIEU_XUAT_KHO_PERMISSION_CODES.WEB_BH_PHIEU_XUAT_KHO_ADD,
  PHIEU_XUAT_KHO_PERMISSION_CODES.WEB_BH_PHIEU_XUAT_KHO_EDIT,
  PHIEU_XUAT_KHO_PERMISSION_CODES.WEB_BH_PHIEU_XUAT_KHO_DELETE,
  PHIEU_XUAT_KHO_PERMISSION_CODES.WEB_BH_PHIEU_XUAT_KHO_STATUS,
  PHIEU_XUAT_KHO_PERMISSION_CODES.WEB_BH_PHIEU_XUAT_KHO_IMPORT,
  PHIEU_XUAT_KHO_PERMISSION_CODES.WEB_BH_PHIEU_XUAT_KHO_EXPORT,
] as const
